module.exports = __webpack_public_path__ + "static/media/Wearconcrete_3_concrete tights.5c32bc4e.jpeg";